import type { MembershipStatus } from "@/hooks/useMembership";

/** Unknown access must go to the Sanctuary's verification gate, not checkout. */
export function sanctuaryEntryPath(membership: Pick<MembershipStatus,
  "hydrated" | "authResolved" | "loading" | "error" | "isMember" | "isAdmin"
>): "/sanctuary" | "/pricing" {
  if (membership.isMember || membership.isAdmin) return "/sanctuary";
  if (!membership.hydrated || !membership.authResolved || membership.loading || membership.error) {
    return "/sanctuary";
  }
  return "/pricing";
}